import axios from "axios";

export const getKlaviyoData = async (apiKey) => {
  const klaviyo_cloud_function_url = "https://us-central1-causalfunnel-21.cloudfunctions.net/CF_Klaviyo_server";
  try {
    const response = await axios.post(klaviyo_cloud_function_url, {
      api_key: apiKey,
    });
    return response.data
  } catch (error) {
    throw error;
  }
};

export const getKlaviyoLists = async (apiKey) => {
  let headersList = {
    Accept: "application/json",
    Authorization: `Klaviyo-API-Key ${apiKey}`,
    revision: new Date().toISOString().split("T")[0],
  };
  let reqOptions = {
    url: "https://a.klaviyo.com/api/lists/",
    method: "GET",
    headers: headersList,
  };
  try {
    const response = await axios(reqOptions);
    return response.data;
  } catch (error) {
    throw error;
  }
};
